<template>

<div class="card card-default">
    <div class="card-body">
      <div class="row">
        <div class="col-md-6">
          <div class="input-group">
            <input
              type="search"
              class="form-control"
              placeholder="Search Supplier"
              v-model="searchTerm"
            >
            <div class="input-group-append">
              <span class="input-group-text"><i class="fa fa-search"></i></span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group text-right">
            <button class="btn btn-primary" @click="openSupplier()">Add Supplier</button>
          </div>
        </div>
      </div>
      <hr>
        <div class="table-responsive table-bordered text-nowrap">
          <table class="table table-hover">
            <thead>
                <tr>
                    <th class="sortable-header" @click="sortBy('name')">
                      Supplier Name
                      <i :class="getSortIcon('name')"></i>
                    </th>
                    <th class="sortable-header" @click="sortBy('registeredCompanyName')">
                      Registered Company Name
                      <i :class="getSortIcon('registeredCompanyName')"></i>
                    </th>
                    <th class="sortable-header" @click="sortBy('bbbeeLevel')">
                      B-BBEE Level
                      <i :class="getSortIcon('bbbeeLevel')"></i>
                    </th>
                    <th class="sortable-header" @click="sortBy('bbbeeStatus')">
                      B-BBEE Status
                      <i :class="getSortIcon('bbbeeStatus')"></i>
                    </th>
                    <th style="width: 8rem"></th>
                </tr>
            </thead>
            <tbody v-if="filteredSuppliers.length > 0">
                <tr v-for="supp in filteredSuppliers" :key="supp.supplierNumber" @click="viewSupplier(supp.supplierNumber)">
                    <td>{{supp.name}}</td>
                    <td>{{supp.registeredCompanyName}}</td>
                    <td>{{supp.bbbeeLevel}}</td>
                    <td>{{supp.bbbeeStatus}}</td>
                    <td class="text-center">
                      <button
                        class="btn btn-sm btn-info m-1"
                        type="button"
                        v-tooltip="'View Supplier'"
                        @click.stop="viewSupplier(supp.supplierNumber)"
                      >
                        <em class="fa fa-eye fa-fw"></em>
                      </button>
                      <button
                        v-if="isAdminUser || isAuthorizedUser"
                        class="btn btn-sm btn-primary"
                        type="button"
                        v-tooltip="'Delete Supplier'"
                        @click.stop="confirmDeleteSupplier(supp)"
                      >
                        <em class="fa fa-trash fa-fw"></em>
                      </button>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr>
                  <td colspan="5">No Suppliers available</td>
                </tr>
              </tbody>
        </table>
        </div>
    </div>

    <modal
      :title="
        emptySupplier.supplierNumber ? 'Edit Supplier' : 'Add New Supplier'
      "
      ref="supplierModal"
      size="modal-lg"
      @save="saveSupplier()"
    >
      <div class="row">
        <div class="form-group col-md-12">
          <label class="control-label"> Supplier Name </label>
          <input
            type="text"
            class="form-control"
            v-model="emptySupplier.name"
          />
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <label class="control-label"> Registered Company Name </label>
          <input
            type="text"
            class="form-control"
            v-model="emptySupplier.registeredCompanyName"
          />
        </div>
        <div class="form-group col-md-6">
          <label class="control-label"> Xero Accounting ID </label>
          <input
            type="text"
            class="form-control"
            v-model="emptySupplier.accountingId"
          />
        </div>
      </div>
    </modal>
</div>

</template>

<script>
import Modal from "@/components/GeneralComponents/Modal";

export default {
    components: {
        Modal
    },
    data: function() {
        return {
          suppliers: [],
          searchTerm: '',
          sortKey: 'name',
          sortOrder: 'asc',
          emptySupplier: {
            name: '',
            registeredCompanyName: '',
            accountingId: '',
          },
        }
    },
    created() {
      this.$root.$emit('SET_PAGE_TITLE', this.$route.meta.title);
    },
    mounted: function() {
      this.getSuppliers();        
    },
    computed: {
      filteredSuppliers() {
        const suppliersWithBbbeeStatus = this.suppliers.map((supplier) => {
          return Object.assign({}, supplier, {
            bbbeeStatus: this.getBbbeeStatus(supplier),
          });
        });

        let filteredSuppliers = suppliersWithBbbeeStatus.filter((supplier) => {
          if (!this.searchTerm) {
            return true;
          }

          const searchTerm = this.searchTerm.toLowerCase();
          const supplierName = (supplier.name || '').toLowerCase();
          const supplierRegisteredCompanyName = (supplier.registeredCompanyName || '').toLowerCase();
          const supplierAccountingId = (supplier.accountingId || '').toLowerCase();
          const supplierBbbeeLevel = (supplier.bbbeeLevel || '').toLowerCase();
          const supplierBbbeeStatus = supplier.bbbeeStatus.toLowerCase();

          return supplierName.includes(searchTerm)
            || supplierRegisteredCompanyName.includes(searchTerm)
            || supplierAccountingId.includes(searchTerm)
            || supplierBbbeeLevel.includes(searchTerm)
            || supplierBbbeeStatus.includes(searchTerm);
        });

        if (!this.sortKey) {
          return filteredSuppliers;
        }

        return [...filteredSuppliers].sort((firstSupplier, secondSupplier) => {
          const firstValue = (firstSupplier[this.sortKey] || '').toLowerCase();
          const secondValue = (secondSupplier[this.sortKey] || '').toLowerCase();
          const sortResult = firstValue.localeCompare(secondValue);

          return this.sortOrder === 'asc' ? sortResult : -sortResult;
        });
      },
      isAuthorizedUser() {
        return this.userContainsPermission(['PRODUCT_MANAGER']);
      },
      isAdminUser() {
        return this.userContainsPermission(['ADMIN']);
      }
    },
    methods: {
      getBbbeeStatus(supplier) {
        if (supplier.nonCompliant) {
          return 'Non-Compliant';
        }

        if (supplier.noCertificate) {
          return 'No Certificate';
        }

        if (supplier.valid) {
          return 'Valid';
        }

        if (supplier.expired) {
          return 'Expired';
        }

        return '';
      },
      sortBy(key) {
        if (this.sortKey === key) {
          this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
          return;
        }

        this.sortKey = key;
        this.sortOrder = 'asc';
      },
      getSortIcon(key) {
        if (this.sortKey !== key) {
          return 'fa fa-sort text-muted';
        }

        return this.sortOrder === 'asc' ? 'fa fa-sort-up' : 'fa fa-sort-down';
      },
      async confirmDeleteSupplier(supplier) {
        try {
          const response = await this.$http.get(this.$config.aimsAPIv3 + 'suppliers/' + supplier.supplierNumber + '/delete-check');
          const deleteCheck = response.data;

          if (!deleteCheck.canDelete) {
            this.showWarningAlert(deleteCheck.message);
            return;
          }

          this.$swal({
            title: 'Are you sure you want to delete this Supplier?',
            text: supplier.name,
            type: 'warning',
            showCancelButton: true,
            cancelButtonColor: '#d33',
            confirmButtonText: 'Delete',
          }).then((result) => {
            if (result.value) {
              this.deleteSupplier(supplier.supplierNumber);
            }
          });
        } catch (error) {
          console.error(error);
          this.showError('Error Checking Supplier Delete Constraints', error);
        }
      },
      deleteSupplier(supplierNumber) {
        this.$http.delete(this.$config.aimsAPIv3 + 'suppliers/' + supplierNumber + '/delete')
          .then(response => {
            if (response.data.errorId) {
              this.showWarningAlert(response.data.message);
              return;
            }

            this.showSuccess(response.data.message);
            this.getSuppliers();
          }, error => {
            console.error(error);
            this.showError('Error Deleting Supplier', error);
          });
      },
      getSuppliers() {
        this.$http.get(this.$config.aimsAPIv3 + 'suppliers/all')
          .then(response => {
            this.suppliers = response.data;
          }, error => {
            console.error(error);
            this.showError('Error Fetching Suppliers', error);
          }).finally(() => {
            this.getEmptySupplier();
          });
      },
      getEmptySupplier() {
        this.$http.get(this.$config.aimsAPIv3 + 'suppliers/empty')
          .then(response => {
            this.emptySupplier = response.data;
          }, error => {
            console.error(error);
            this.showError('Error Fetching Suppliers', error);
          });
      },
      openSupplier() {
        this.$refs.supplierModal.open();
      },
      saveSupplier() {
        this.emptySupplier.supplierNumber ? this.updateSupplier() : this.createSupplier();
      },
      createSupplier() {
        this.$refs.supplierModal.isLoading();
        this.$http.post(this.$config.aimsAPIv3 + 'suppliers/create', this.emptySupplier)
          .then(response => {
            this.getSuppliers();
            this.$refs.supplierModal.close();
          }, error => {
            console.error(error);
            this.showError('Error Fetching Suppliers', error);
          });
      },
      updateSupplier() {
        this.$refs.supplierModal.isLoading();
        this.$http.put(this.$config.aimsAPIv3 + 'suppliers/update', this.emptySupplier)
          .then(response => {
            this.getSuppliers();
            this.$refs.supplierModal.close();
          }, error => {
            console.error(error);
            this.showError('Error Fetching Suppliers', error);
          });
      },
      viewSupplier: function(supplierNumber) {
          this.$router.push({name: 'supplier', params: {'supplierNumber': supplierNumber}});
      }
    }
}

</script>

<style scoped lang="scss">
.sortable-header {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;

  &:hover {
    background-color: #4a5066;
  }

  i {
    margin-left: 5px;
    font-size: 0.85em;
  }
}
</style>
